import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { Verified as VerifiedIcon } from "@mui/icons-material";
import ApiService from "../../../modules/APIService.interceptors";
import { useNotifier } from "../../../hooks/useNotifier";
import ConfirmActionDialog from "./ConfirmActionDialog";

const VERIFY_PHONE_DIALOG_DESCRIPTION = (
  <>
    Vas a marcar el número guardado de este usuario como <strong>verificado</strong>. Es una acción de
    administración: no envía SMS ni código al dispositivo.
  </>
);

const VERIFY_PHONE_DIALOG_CONFIRM_PROMPT =
  "¿Confirmás que el número es correcto y querés marcarlo como verificado?";

const VerifyPhoneButton = ({ userId, phone, setPhone_verified }) => {
  const notify = useNotifier();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const normalizedPhone = String(phone ?? "").trim();

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleConfirm = async () => {
    if (!userId || !normalizedPhone) return;
    try {
      setLoading(true);
      await ApiService.updateUser(userId, {
        phone: normalizedPhone,
        phone_verified: true,
      });
      setPhone_verified(true);
      setOpen(false);
      notify("Teléfono verificado correctamente", "success");
    } catch (e) {
      if (e?.response?.data?.code === "PHONE_ALREADY_EXISTS") {
        notify("El número ya está en uso por otro usuario.", "error");
      } else {
        notify("Error al verificar el teléfono.", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpen}
        disabled={!userId || !normalizedPhone}
        startIcon={<VerifiedIcon />}
      >
        Verificar teléfono
      </Button>

      <ConfirmActionDialog
        open={open}
        onClose={handleClose}
        title="Verificar número de teléfono"
        description={VERIFY_PHONE_DIALOG_DESCRIPTION}
        confirmPrompt={VERIFY_PHONE_DIALOG_CONFIRM_PROMPT}
        onConfirm={handleConfirm}
        loading={loading}
        confirmColor="success"
        confirmLabel="Sí, verificar"
      >
        <Typography variant="body2" sx={{ mt: 2, fontFamily: "monospace", wordBreak: "break-all" }}>
          Número: {normalizedPhone || "—"}
        </Typography>
      </ConfirmActionDialog>
    </>
  );
};

export default VerifyPhoneButton;
